import { render, staticRenderFns } from "./OwnGoodsList.vue?vue&type=template&id=7659be58&scoped=true"
import script from "./OwnGoodsList.vue?vue&type=script&lang=js"
export * from "./OwnGoodsList.vue?vue&type=script&lang=js"
import style0 from "./OwnGoodsList.vue?vue&type=style&index=0&id=7659be58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7659be58",
  null
  
)

export default component.exports